import Alpha from "./pages/alpha";
import Beta from "./pages/beta";

export default {
  Alpha,
  Beta,
};
